import React from 'react';
import PropTypes from 'prop-types';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { Loader } from 'shared/components';
import { AppointmentsEmptyPlaceholder } from '../';

import theme from './AppointmentCustomTemplateEmptyPlaceholder.scss';

const propTypes = {
  template: PropTypes.string,
  configRequestStatus: PropTypes.string.isRequired,
};

const defaultProps = {
  template: null,
};

const AppointmentCustomTemplateEmptyPlaceholder = ({
  template,
  configRequestStatus,
}) => {
  if (configRequestStatus === requestsStatuses.pending) return <div className={ theme.loader }><Loader /></div>;
  if (!template && configRequestStatus === requestsStatuses.success) return <AppointmentsEmptyPlaceholder />;

  return (
    <div className={ theme.root }>
      <div dangerouslySetInnerHTML={{ __html: template }} />
    </div>
  );
};

AppointmentCustomTemplateEmptyPlaceholder.propTypes = propTypes;
AppointmentCustomTemplateEmptyPlaceholder.defaultProps = defaultProps;

export default AppointmentCustomTemplateEmptyPlaceholder;
